import { PageFooter } from "PFApp/components/page_footer";
import { Button } from "PFComponents/button";
import { Cover } from "PFComponents/cover";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { useActivityFormStore } from "../../activity_form_store";
import { useEngagementScopeForm } from "../../hooks/use_engagement_scope_form";
import css from "./footer.module.scss";
import { EngagementFooter } from "./footer_variants/engagement_footer";
import { EngagementScopeFooter } from "./footer_variants/engagement_scope_footer";
import { StandardFooter } from "./footer_variants/standard_footer";

export const Footer = () => {
  const { t } = useTranslation("activities", { keyPrefix: "form.footer" });
  const navigate = useNavigate();
  const { isEngagementScope, parentActivityId } = useEngagementScopeForm();

  const { isEngagement } = useActivityFormStore((state) => state.activityStatus);

  const {
    formState: { isSubmitting }
  } = useFormContext();

  const handleCancel = () => {
    if (isEngagementScope) {
      navigate(`/activities/${parentActivityId}`);
      return;
    }
    navigate(-1);
  };

  return (
    <PageFooter className={css.footerContent}>
      {isSubmitting && <Cover />}
      <Button kind="secondary" text={t("cancel")} onClick={handleCancel} className={css.footerButton} />
      {isEngagement && <EngagementFooter />}
      {isEngagementScope && <EngagementScopeFooter />}
      {!isEngagement && !isEngagementScope && <StandardFooter />}
    </PageFooter>
  );
};
